import { SvgIconProps } from '@mui/material';

import { CrIcon } from './components/Icons/CR';
import { FIAGROIcon } from './components/Icons/FIAGRO';
import { FIDCIcon } from './components/Icons/FIDC';
import { FIIIcon } from './components/Icons/FII';
import { SponsorLevel } from '../2025/types';

export const markets = ['FIDC', 'FIAGRO', 'CRs', 'FII'];
export const MARKET_ICONS: Record<string, React.ComponentType<SvgIconProps>> = {
  FIDC: FIDCIcon,
  FIAGRO: FIAGROIcon,
  CRs: CrIcon,
  FII: FIIIcon,
};

export const sectionTitleGradient =
  'linear-gradient(90deg, #FF8211 0%, #F8C495 100%)';
export const transition = 'all 0.2s ease-in-out';

export const CHART_COLORS = [
  '#FD841F',
  '#CD104D',
  '#F2CD5C',
  '#600446',
  '#35D0BA',
  '#A61F69',
];

export const colors = {
  bg: '#131313',
  bgSection: '#1A1A1A',
  white: '#FFFFFF',
  orange: '#FF8211',
  orangeLight: '#F8C495',
  text: '#ADB2B1',
  textDim: '#767676',
  primary: 'primary.main',
  secondary: 'secondary.main',
};

export const sections = [
  { title: 'Patrocinadores' },
  { title: 'Carta ao leitor' },
  { title: 'Abertura' },
  {
    title: 'Mercado',
    subsections: [{ title: 'Primário' }, { title: 'Secundário' }],
  },
  { title: 'Estoque' },
  { title: 'Rankings' },
  { title: 'Artigos' },
  { title: 'Vídeos' },
];

export const SPONSOR_TIER_DURATION = {
  [SponsorLevel.DIAMOND]: 21000,
  [SponsorLevel.PLATINUM]: 13000,
  [SponsorLevel.GOLD]: 8000,
  [SponsorLevel.SILVER]: 5000,
  [SponsorLevel.BRONZE]: 3000,
};
